import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { api } from "./api";
import { useAuth } from "./auth";

/**
 * v3.9.3 — unread conversation count for the message-icon badge.
 * Polls every 30s, and refreshes on navigation so opening/leaving a thread
 * (which marks it read server-side) updates the badge promptly.
 */
export function useUnreadMessages(): number {
  const { user } = useAuth();
  const [loc] = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!user) { setCount(0); return; }
    let alive = true;
    setCount(0);
    const load = () => api.messagesUnreadCount().then(count => { if (alive) setCount(count); }).catch(() => {});
    load();
    const h = setInterval(load, 30000);
    // v3.9.67 (QA #7) — refresh on tab focus so a new message shows on the badge promptly.
    const onFocus = () => { if (document.visibilityState === "visible") load(); };
    window.addEventListener("focus", onFocus);
    window.addEventListener("dispute-read", load);
    document.addEventListener("visibilitychange", onFocus);
    return () => { alive = false; clearInterval(h); window.removeEventListener("focus", onFocus); window.removeEventListener("dispute-read", load); document.removeEventListener("visibilitychange", onFocus); };
  }, [user?.id, user?.activeContext, loc]);
  return count;
}
